// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33nks","top":"styles_top__Q-m8f"};